// extracted by mini-css-extract-plugin
export default {"chipsText":"Chip_chipsText__qeN-J","chip":"Chip_chip__nOr7v","deleteButton":"Chip_deleteButton__vMPRy"};